import React, {Component} from 'react';
import { connect } from 'react-redux'
import StartList from './StartList'
import ResultList from './ResultList'
import {STARTLIST, RESULTLIST, CHECKPOINT} from './../../util/consts'
import { competitorsForCurrentSelection, competitorsAtCurrentCheckpoint, currentCheckpointID} from '../../selectors/currentItemsAndLists';

class CompetitorList extends Component {

    showList = (id) => {
        if( id === 0){
            return STARTLIST
        }
        else if( id === 9999){
            return RESULTLIST
        }
        else if( id) {
            return CHECKPOINT
        }
        else {
            return null
        }
    }
    
    render() {
        return (
            <div>
                {this.showList( this.props.currCheckpointID) === STARTLIST ? 
                    <StartList competitors={this.props.competitors} />
                    : null
                }
                {this.showList( this.props.currCheckpointID) === RESULTLIST ? 
                    <ResultList competitors={this.props.competitors} event={this.props.event}/>
                    : null
                }
                {this.showList( this.props.currCheckpointID) === CHECKPOINT? 
                    <ResultList competitors={this.props.competitorsAtCurrentCheckpoint}  event={this.props.event}/>
                    : null
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    ui: state.ui
    , competitors: competitorsForCurrentSelection( state)
    , currCheckpointID: currentCheckpointID( state)
    , competitorsAtCurrentCheckpoint: competitorsAtCurrentCheckpoint( state)
})

export default connect( mapStateToProps, null )(CompetitorList);


